import React from 'react';
import {Link} from 'react-router';
import Modal from 'react-responsive-modal';
import { Alert} from 'reactstrap';
import axios from 'axios';
import TextField from 'material-ui/TextField';
import InputMask from 'react-input-mask';
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";

import {
  Container, Row, Col,  DropdownToggle, //FormGroup, Input,
  UncontrolledButtonDropdown, DropdownMenu, DropdownItem, 
} from 'reactstrap';

class NavbarDrop extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modalOpen:false,
      email: '',
      nome: '',
      telefone:'',
      queroSer:'',
      errorFormat: ''      
    };
    this.styles = {
      input: {
        width: '100%'
      },
      col: {
        marginTop: 0,
        paddingBottom: 0
    },      
      label: {
        margin: 0
      }   
    };
    this.errorFormat = {
      email: ''
    };
    
  }
  openModal() {
    let state = this.state;

    state.email = '';
    state.nome  =  '';
    state.telefone = '';
    state.queroSer = '';
    state.modalOpen = true;
    this.setState(state);
  }
  closeModal() {
    let state = this.state;
    state.modalOpen = false;
    this.setState(state);
  }

// Paulo - Submissão do formulário de 
validateTell(id){
  document.getElementById('id_success').style.display = 'none';  
  let tel = document.getElementById(id).value.replace(/[^0-9]/g,'').length;
  if (tel == 11 || tel == 0) {
    document.getElementById('id_alerta').innerHTML = '';
    document.getElementById("alert_"+id).style.display="none";
  }else{
    document.getElementById("id_alerta").style.display= "block";
    document.getElementById('id_alerta').innerHTML = 'Número inválido.';
  }
}

validateCpfDependent(id){
  this.validateCpf(id);
}
validateEmail(id) {
  document.getElementById('id_success').style.display = 'none';  
  let email = document.getElementById(id).value;
  let emailReg=/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

  if (this.props.admin == false) {
    if(!emailReg.test(email) || email == ""){
   
      document.getElementById("id_alerta").style.display= "block";
      document.getElementById('id_alerta').innerHTML = 'E-mail inválido. Formato esperado: email@exemplo.com';


    }else{
      document.getElementById('id_alerta').innerHTML = '';
      document.getElementById("id_alerta").style.display= "none";
    }
  }
  else {
    if (email != '') {
      if(!emailReg.test(email)) {
 
        document.getElementById("id_alerta").style.display= "block";
        document.getElementById('id_alerta').innerHTML = 'E-mail inválido. Formato esperado: email@exemplo.com';

      }
      else {
        document.getElementById('id_alerta').innerHTML = '';
        document.getElementById("id_alerta").style.display= "none";
      }
    }
    else {
      document.getElementById('id_alerta').innerHTML = '';
      document.getElementById("id_alerta").style.display= "none";
    }
  }


}
onChange(e) {
  let state = this.state;
  
if (e.target.id === 'fm_nome')
   state.nome = e.target.value;
if (e.target.id === 'fm_telefone')
   state.telefone = e.target.value;   
   if (e.target.id === 'fm_email')
   state.email = e.target.value;  
this.setState(state);


}

onValidaCampos(forms) {
  document.getElementById('id_success').style.display = 'none';  

  let result = false;

  if (forms.email === '' || forms.nome === '' || forms.queroSer === '' || forms.telefone === '') {
    document.getElementById('id_alerta').innerHTML = 'É necessário o preenchimento de todos os campos.';
    document.getElementById('id_alerta').style.display = 'block';  
/*     if (forms.queroSer === '')
        
       
    document.getElementById('fm_telefone').focus(); */
  } else {
    document.getElementById('id_alerta').innerHTML = '';
    document.getElementById("id_alerta").style.display= "none"; 
    result = true;
  }
  return result;

}

// Valida campos de e-mail
onBlurField(e) {
  // Se o campo for do tipo email
  if (e.target.type === 'email') {
    document.getElementById("alert_fm_email").style.display= "none"; 
    // Se o conteúdo não for válido
    if (!e.target.validity.valid) {
      this.errorFormat.email = 'Formato esperado: email@exemplo.com';

    }
    // Se o conteúdo for válido, retira mensagem de erro
    else
      this.errorFormat.email = '';
      document.getElementById('i_error').innerHTML = this.errorFormat.email;
      document.getElementById('i_error').style.display = 'block';     
      document.getElementById("alert_fm_email").style.display= "block"; 
  }

}

onChangeSelect(event, index, payload) {
  let state = this.state;
  state.queroSer = payload;
  this.setState(state);

}
onSubmitForm(e) {
    e.preventDefault(e);

    let forms = {
      queroSer : this.state.queroSer,
      nome : this.state.nome,
      email : this.state.email,
      telefone: this.state.telefone
     }; 
    if (!this.onValidaCampos(forms)) {
        return false;
    }


   // axios.post("https://connect.pabbly.com/workflow/sendwebhookdata/IjIxMzU3MSI_3D", forms)
   axios.post("https://connect.pabbly.com/workflow/sendwebhookdata/IjE3MTkxMyI_3D", forms)
    .then(() => {
        let state = this.state;
        state.email = '';
        state.nome  =  '';
        state.telefone = '';
        state.queroSer = 'QUERO SER'; 
        this.setState(state);

        document.getElementById('id_success').innerHTML = 'Suas informações foram registardas com sucesso. Entraremos em contato em breve.';
        document.getElementById('id_success').style.display = 'block';  
    }).catch(function (erro) {
      let state = this.state;
      state.tipoMesagem = 'warning';
      this.setState(state);
      document.getElementById('id_alerta').innerHTML = "Erro ao enviar as informações : "+erro;
      document.getElementById('id_alerta').style.display = 'block';        

    }.bind(this)
    );
 }

  render() {
    return (
      <div>
        {/*************************** NAVBAR DROPDOWN **************************/}
        <Container id="navbar-drop">
          <Row>
            <Col xs="3" sm="3" md="3" lg="3" style={{paddingRight: 0, paddingLeft: 0}}>
                <UncontrolledButtonDropdown style={{width:'100%', height:48}}>
                <DropdownToggle aria-expanded={true} style={{width:'100%'}} className="button-drop" caret>
                  CLIENTE
                </DropdownToggle>
                <DropdownMenu className="drop-menu drop-menu-left">
                  <Link target="_blank" to="https://corporativo.dentalcenterpb.com.br/SYS/?TipoUsuario=1">  
                    <DropdownItem className="drop-item">PORTAL</DropdownItem>
                  </Link>
                  <Link to={'carteirinha'}>  
                    <DropdownItem className="drop-item">CARTEIRINHA</DropdownItem>
                  </Link>
                  <Link to={'boletodigital'}>  
                    <DropdownItem className="drop-item">BOLETO DIGITAL</DropdownItem>
                  </Link>
                  <Link to={'situacaoproposta'}>  
                    <DropdownItem className="drop-item">SITUAÇÃO DA PROPOSTA</DropdownItem>
                  </Link>
                  <Link>  
                    <DropdownItem className="drop-item-final" onClick={this.openModal.bind(this)}>QUERO SER DENTAL</DropdownItem>
                  </Link>
                </DropdownMenu>
                </UncontrolledButtonDropdown>
            </Col>
            <Col xs="3" sm="3" md="3" lg="3" style={{paddingRight: 0, paddingLeft: 0}}>
              <UncontrolledButtonDropdown style={{width:'100%', height:48}}>
              <DropdownToggle style={{width:'100%'}} className="button-drop" caret>
                  EMPRESA
              </DropdownToggle>
              <DropdownMenu className="drop-menu" style={{width:'100%'}}>
                <Link target="_blank" to="https://corporativo.dentalcenterpb.com.br/SYS/?TipoUsuario=2">  
                  <DropdownItem className="drop-item">GESTOR ONLINE</DropdownItem>
                </Link>
                <Link>  
                  <DropdownItem className="drop-item-final" onClick={this.openModal.bind(this)}>QUERO SER DENTAL</DropdownItem>                  
                </Link>
              </DropdownMenu>
              </UncontrolledButtonDropdown>
            </Col>
            <Col xs="3" sm="3" md="3" lg="3" style={{paddingRight: 0, paddingLeft: 0}}>
                <UncontrolledButtonDropdown style={{width:'100%', height:48}}>
                <DropdownToggle style={{width:'100%'}} className="button-drop" caret>
                    DENTISTA
                </DropdownToggle>
                <DropdownMenu className="drop-menu">
                  <Link target="_blank" to="https://corporativo.dentalcenterpb.com.br/SYS/?TipoUsuario=3">  
                    <DropdownItem className="drop-item">PORTAL DENTISTA</DropdownItem>
                  </Link>
                  <Link target="_blank" to="https://corporativo.dentalcenterpb.com.br/SYS/?TipoUsuario=4">  
                    <DropdownItem className="drop-item">PORTAL CLÍNICA</DropdownItem>
                  </Link>
                  <Link>  
                    <DropdownItem className="drop-item-final" onClick={this.openModal.bind(this)}>QUERO SER DENTAL</DropdownItem>
                  </Link>
                </DropdownMenu>
                </UncontrolledButtonDropdown>
            </Col>
            <Col xs="3" sm="3" md="3" lg="3" style={{paddingRight: 0, paddingLeft: 0}}>
                <UncontrolledButtonDropdown style={{width:'100%', height:48}}>
                <DropdownToggle style={{width:'100%'}} className="button-drop" caret>
                  CORRETOR
                </DropdownToggle>
                <DropdownMenu className="drop-menu drop-menu-right">
                  <Link to={'panel'}>
                    <DropdownItem className="drop-item">GESTÃO DE VENDAS</DropdownItem>
                  </Link>
                  <Link target="_blank" to="https://corporativo.dentalcenterpb.com.br/SYS/?TipoUsuario=7">  
                    <DropdownItem className="drop-item">GESTÃO FIN. CORRETORA</DropdownItem>
                  </Link>
                  <Link target="_blank" to="https://corporativo.dentalcenterpb.com.br/SYS/?TipoUsuario=6"> 
{/*                   <Link target="_blank" to="https://dentalcenter.s4e.com.br/SYS/?TipoUsuario=6">   */}
                    <DropdownItem className="drop-item">GESTÃO FIN. VENDEDOR</DropdownItem>
                  </Link>
                  <Link>  
                    <DropdownItem className="drop-item-final" onClick={this.openModal.bind(this)}>QUERO SER DENTAL</DropdownItem>
                  </Link>
                </DropdownMenu>
                </UncontrolledButtonDropdown>
            </Col>
          </Row>
        </Container>
        
        {/*************************** CIDADE ***************************/}
        <Modal
          open={this.state.modalOpen} onClose={this.closeModal.bind(this)}
          center showCloseIcon={false}
          classNames={{ modal: 'custom-modal-parcial_dental'}}
        >
          <div id="formgroup_select_dental" >  
            <Container style={{marginTop:10}}>
              <Row style={{marginBottom:30, paddingLeft:15}}>
                <Col>  
                  <div className="logo">&nbsp;</div>
                </Col>
                <Col className="icon-scroll-dental">
                  <i onClick={this.closeModal.bind(this)}className="fas fa-times-circle color_fa">{''}</i>
                </Col>
              </Row>
              <p className="text-modal" style={{ marginBottom:0, marginTop:0, fontSize : 16 }}>
              Que boa notícia! Em breve você fará parte do time Dental Center. Por favor deixe suas informações, entraremos em contato.
              </p>
              <div >
              <Alert id="id_alerta" variant='danger'  color='danger' style={{display: 'none', marginBottom:0, marginTop:0, fontSize : 14 }}>
                   </Alert>   
               <Alert id="id_success"  variant='success'  color='success' style={{display: 'none', marginBottom:0, fontSize : 14}}>
                   </Alert>  
              </div>
              <Row >
                <Col>

                  <div id="choose_city_dental" >

                    <Row> 
                      <Col>
                      <div style={{margin:0, textAlign:'left', marginBottom:0}}>
                          <SelectField
                            id="i_select"
                            floatingLabelText="QUERO SER"
                            fullWidth={true}
                            name="querSer"
                            value={this.state.queroSer}
                            label={this.state.queroSer}
                            onChange={this.onChangeSelect.bind(this)}
                          >
                            <MenuItem value={""} label="QUERO SER" primaryText="QUERO SER..."/>
                            <MenuItem value={"CLIENTE PESSOA FÍSICA..."} label="CLIENTE PESSOA FÍSICA..." primaryText="CLIENTE PESSOA FÍSICA..."/>
                            <MenuItem value={"CLIENTE EMPRESA"} label="CLIENTE EMPRESA..." primaryText="CLIENTE EMPRESA..."/>
                            <MenuItem value={"CORRETOR"} label="CORRETOR..." primaryText="CORRETOR..."/>
                            <MenuItem value={"DENTISTA ASSOCIADO"} label="DENTISTA ASSOCIADO..." primaryText="DENTISTA ASSOCIADO..."/>

                          </SelectField>
                      </div>
                        <div style={{margin:0, textAlign:'left', marginBottom:0}}>
                        <TextField
                          id="fm_nome"
                          hintText="Seu nome"
                          floatingLabelText="Seu nome"
                          type="text"
                          name="nome"
                          value={this.state.nome}
                          onChange={this.onChange.bind(this)}
                          fullWidth={true}
                        />                          

                        </div>
                        <div style={{margin:0, textAlign:'left', marginBottom:0}}>
                        <TextField
                          id="fm_email"
                          hintText="Seu melhor email"
                          floatingLabelText="Seu melhor email"
                          type="email"
                          name="email"
                          value={this.state.email}
                          onBlur={this.validateEmail.bind(this, "fm_email")}                          
                          onChange={this.onChange.bind(this)}
                          fullWidth={true}
                        />                            
 
                        </div>
                        <div>
                        <TextField
                          hintText="Seu telefone WhastApp"
                          id="fm_telefone"
                          fullWidth={true}

                          floatingLabelText="Seu telefone Whatsapp"
                          >
                          <InputMask
                            id="fm_telefone"
                            mask="(99) \9 9999-9999"
                            maskChar=" "
                            type="tel"
                            name="telefone"
                            value={this.state.telefone}
                            onChange={this.onChange.bind(this)}
                            />
                       </TextField>                        
 
                        </div>
                        <div onClick={this.onSubmitForm.bind(this)} className="button_contact_dental">
                             <span   >ENVIAR</span>
                        </div>                        
                      </Col>
                    </Row>

                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </Modal>
      </div>
    );
  }

}

export default NavbarDrop;



/** WEBPACK FOOTER **
 ** ./src/components/HomePageNew/NavbarDrop.js
 **/